import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import PopupOverview from '../Popup/PopupOverview';
import s from './HistoryEvents.css';
import HistoryEventRow from './HistoryEventRow';
import HistoryEventsHeader from './HistoryEventsHeader';
import HistoryEventsFilterbox from './HistoryEventsFilterbox';
import { getTableHeaderSoftenerData, getTableHeaderSuperiorData } from './HistoryMessages';
import InfiniteScrollWithLoadMore from '../InfiniteScroll/InfiniteScrollWithLoadMore';
import Loader from '../Loader';

const MAX_NUMBER_OF_AUTOLOADS = 1;

class HistoryEventsView extends React.Component {
  constructor(props) {
    super(props);
    const colorId = '';
    this.state = {
      colorId,
      filteredEvents: [],
    };
  }

  onClick = (data, event) => {
    const eventId = data.get(1);
    this.setState({
      colorId: eventId,
    });
  };

  componentWillReceiveProps = (newProps) => {
    if (newProps.deviceDocument.get('serial') === null){
      this.onFilterEvent([]);
    }
  }

  showBox = (item, index, filter, deviceType) => {
    const value = filter.get(item.name);
    const wrappedStyle =
      deviceType === 'superior'
        ? cx(s.row_container, s.spirotech_header_color)
        : cx(s.row_container, s.header_color);
    if (+value === 1) {
      return (
        <th className={wrappedStyle} key={index}>
          <FormattedMessage {...item.text} />
        </th>
      );
    }
    return null;
  };

  onFilterEvent = values => {
    this.setState({
      filteredEvents: values,
    });
  };

  getHeader = (
    deviceDocument,
    softenerFilterDocument,
    superiorFilterDocument,
  ) => {
    const deviceType = deviceDocument.get('deviceType');
    const screenType = deviceDocument.get('screenType');
    let data = [];
    let filter = null;
    switch (deviceType) {
      case 'softener':
      case 'charlie':
      case 'simplex':
        data = getTableHeaderSoftenerData(screenType);
        filter = softenerFilterDocument;
        break;
      case 'superior':
        data = getTableHeaderSuperiorData();
        filter = superiorFilterDocument;
        break;
      default:
        break;
    }

    return (
      <tr>{data.map((item, index) => this.showBox(item, index, filter, deviceType))}</tr>
    );
  };

  render() {
    const {
      deviceDocument,
      deviceDocumentPaging,
      documentSoftenerFilter,
      documentSuperiorFilter,
      documentRows,
    } = this.props;
    const rowsData = documentRows;
    const events = deviceDocument && deviceDocument.get('events');
    const numberOlderItemsFetched = deviceDocumentPaging && deviceDocumentPaging.get('numberOlderItemsFetched');
    const requestInProgress = deviceDocument && deviceDocument.get(
      'requestInProgress',
    );

    const hasMore =
      deviceDocumentPaging.get('itemsPerPage') * deviceDocumentPaging.get('currentPage') <
      deviceDocumentPaging.get('itemsCount');

    if (
      deviceDocument !== 'undefined' &&
      deviceDocument.get('serial') !== null &&
      +deviceDocument.get('documentType') === 1
    ) {
      if (!requestInProgress && rowsData) {
        return (
          <PopupOverview
            className={s.Popup__editdevice}
            onClose={this.props.onClose}
            deviceType={deviceDocument.get('deviceType')}
            overrideOnClose
          >
            <HistoryEventsFilterbox
              documentSoftenerFilter={documentSoftenerFilter}
              documentSuperiorFilter={documentSuperiorFilter}
              deviceDocument={deviceDocument}
            />
            <HistoryEventsHeader
              events={events}
              onChange={this.onFilterEvent}
              onSave={this.props.onSavePDF}
              filteredEvents={this.state.filteredEvents}
              onClearFilter={this.props.onClearFilter}
              deviceType={deviceDocument.get('deviceType')}
              deviceName={deviceDocument.get('deviceName')}
              deviceSerial={deviceDocument.get('serial')}
              deviceDocumentPaging={deviceDocumentPaging}
            />
            <table className={s.Table_container}>
              <thead>
                {this.getHeader(
                  deviceDocument,
                  documentSoftenerFilter,
                  documentSuperiorFilter,
                )}
              </thead>
            <InfiniteScrollWithLoadMore
              loadMore={this.props.getNextPage}
              hasMore={hasMore}
              showLoadMore={numberOlderItemsFetched >= MAX_NUMBER_OF_AUTOLOADS}
              className={cx()}
              table
            >
                {rowsData.map((row, index) => (
                  <HistoryEventRow
                    row={row} 
                    key={index} 
                    onClick={this.onClick.bind(this, row.get(2))}
                    colorId ={this.state.colorId}
                    documentSoftenerFilter={documentSoftenerFilter}
                    documentSuperiorFilter={documentSuperiorFilter}
                    filteredEvents={this.state.filteredEvents}
                    deviceDocument={deviceDocument}
                  />
                ))}
              </InfiniteScrollWithLoadMore>
            </table>
          </PopupOverview>
        );
      }
      return (
        <PopupOverview
          className={s.Popup__editdevice}
          onClose={this.props.onClose}
          overrideOnClose
        >
          <Loader block />
        </PopupOverview>
      );
    }
    return null;
  }
}

HistoryEventsView.propTypes = {
  deviceDocument: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  deviceDocumentPaging: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSoftenerFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSuperiorFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentRows: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onClose: PropTypes.func.isRequired,
  onSavePDF: PropTypes.func.isRequired,
  getNextPage: PropTypes.func.isRequired,
  onClearFilter: PropTypes.func.isRequired,
};

export default withStyles(s)(HistoryEventsView);



// WEBPACK FOOTER //
// ./src/components/HistoryEvents/HistoryEventsView.js